import GeoJSON, { GeoJSONFeatureCollection } from 'ol/format/GeoJSON';

import kinks from '@turf/kinks';

export const hasSelfIntersections = (featureCollection: GeoJSONFeatureCollection, geoJson: GeoJSON): boolean => {
  return geoJson
    .readFeatures(featureCollection)
    .map((feature) => geoJson.writeFeatureObject(feature))
    .some((collectionFeature) => {
      const intersections = kinks(collectionFeature);
      return intersections.features.length > 0;
    });
};
